export class DocumentType {
    id: number;
    name: string;
    type: string;
}